import React from "react";

import useAdminParams from "../hooks/useAdminParams";
import { generatePath } from "react-router-dom";
import { LinkContainer } from "react-router-bootstrap";

import Breadcrumb from "react-bootstrap/cjs/Breadcrumb";

import isValidId from "../functions/isValidId";

import * as routes from "routes";

const ResourceBreadcrumbs = () => {
  const { setId, portalId, groupId, resourceId } = useAdminParams();

  if (isValidId(portalId))
    return (
      <Breadcrumb>
        <LinkContainer to={generatePath(routes.PORTAL_RESOURCES, { portalId })}>
          <Breadcrumb.Item>Portal Resources</Breadcrumb.Item>
        </LinkContainer>
        {isValidId(groupId) && !isValidId(resourceId) && (
          <LinkContainer to={generatePath(routes.PORTAL_RESOURCE_GROUP, { portalId, groupId })}>
            <Breadcrumb.Item>Edit Group</Breadcrumb.Item>
          </LinkContainer>
        )}
        {isValidId(resourceId) && (
          <LinkContainer
            to={generatePath(routes.PORTAL_RESOURCE, {
              portalId,
              groupId,
              resourceId,
            })}
          >
            <Breadcrumb.Item>Edit Resource</Breadcrumb.Item>
          </LinkContainer>
        )}
      </Breadcrumb>
    );

  return (
    <Breadcrumb>
      <LinkContainer to={routes.RESOURCES}>
        <Breadcrumb.Item>Resource Sets</Breadcrumb.Item>
      </LinkContainer>
      {isValidId(setId) && (
        <LinkContainer to={generatePath(routes.RESOURCE_SET_ID, { setId })}>
          <Breadcrumb.Item>Edit Set</Breadcrumb.Item>
        </LinkContainer>
      )}
      {isValidId(groupId) && !isValidId(resourceId) && (
        <LinkContainer to={generatePath(routes.RESOURCE_GROUP_ID, { setId, groupId })}>
          <Breadcrumb.Item>Edit Group</Breadcrumb.Item>
        </LinkContainer>
      )}
      {isValidId(resourceId) && (
        <LinkContainer
          to={generatePath(routes.RESOURCE_ID, {
            setId,
            groupId,
            resourceId,
          })}
        >
          <Breadcrumb.Item>Edit Resource</Breadcrumb.Item>
        </LinkContainer>
      )}
    </Breadcrumb>
  );
};

export default ResourceBreadcrumbs;
